var gql = require("@apollo/client").gql;

const ADDRESS_TARIFFS_INFO_QUERY_V2 = gql`
    query AddressTariffsInfo($address_id: Int!) {
        addressTariffsInfoV2(address_id: $address_id) {
            cnt_tariffs
            speed {
                min
                max
            }
            price {
                min
                max
            }
        }
    }
`;

module.exports = ADDRESS_TARIFFS_INFO_QUERY_V2;
